import { render, staticRenderFns } from "./HistoryRelatedWidget.vue?vue&type=template&id=701dc906"
import script from "./HistoryRelatedWidget.vue?vue&type=script&lang=js"
export * from "./HistoryRelatedWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports